import * as React from "react";
import {
  Text,
  View,
  // Button, a part of cleaner code
  Image,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  StyleSheet,
  Platform,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
import { disableTransactionFilterModal } from "../redux/actions/UIStateActions";
import GlobalStyles from "../components/GlobalStyles";
import { setTransactionFilter } from "../redux/actions/TransactionActions";
import DateTimePickerModal from "react-native-modal-datetime-picker";
import { useNavigation } from "@react-navigation/native";

import DropDownPicker from "react-native-dropdown-picker";
import { useSelector } from "react-redux";
// import { label } from "aws-amplify"; a part of cleaner code

const BGimage = require("../assets/res/blue_bg.png");
export default function TransactionsFilterForm(props) {
  const navigation = useNavigation();
  const currStartDate = useSelector(
    (state) => state.transaction.transactionsFilter.dateFilterStart
  );
  const currEndDate = useSelector(
    (state) => state.transaction.transactionsFilter.dateFilterEnd
  );
  const currValueLow = useSelector(
    (state) => state.transaction.transactionsFilter.valueFilterLow
  );
  const currValueHigh = useSelector(
    (state) => state.transaction.transactionsFilter.valueFilterHigh
  );
  const currCategory = useSelector(
    (state) => state.transaction.transactionsFilter.categoryFilter
  );
  const curr_date = new Date();
  const date_y = curr_date.getFullYear(),
    date_m = curr_date.getMonth();
  const [startDate, setStartDate] = React.useState(new Date(date_y, date_m, 1));
  const [startDateModified, setStartDateModified] = React.useState(false);
  const [startDateShow, setStartDateShow] = React.useState(false);
  const [endDate, setEndDate] = React.useState(new Date(date_y, date_m + 1, 0));
  const [endDateModified, setEndDateModified] = React.useState(false);
  const [endDateShow, setEndDateShow] = React.useState(false);
  const onStartDateChange = (selectedDate) => {
    const currentDate = selectedDate || date;
    setStartDateShow(false);
    setStartDate(currentDate);
    setStartDateModified(true);
  };
  const onEndDateChange = (selectedDate) => {
    const currentDate = selectedDate || date;
    setEndDateShow(false);
    setEndDate(currentDate);
    setEndDateModified(true);
  };

  const showStartDateMode = (currentMode) => {
    setStartDateShow(true);
  };

  const showEndDateMode = (currentMode) => {
    setEndDateShow(true);
  };
  const [valueLow, setValueLow] = React.useState("");
  const [valueHigh, setValueHigh] = React.useState("");

  const [categorySelect, setCategorySelect] = React.useState(null);
  var categoryList = useSelector((state) => state.transaction.categoryList);
  const filterSet = useSelector((state) => state.transaction.filterSet);
  var ran = 0;

  var arrCategoryList = [];

  for (var key in categoryList) {
    if (categoryList.hasOwnProperty(key)) {
      const labVal = {
        label: categoryList[key].name,
        value: categoryList[key].name,
      };
      arrCategoryList.push(labVal);
    }
  }

  const resetFilter = () => {
    // Date
    setStartDate(new Date(date_y, date_m, 1));
    setStartDateModified(false);
    setEndDate(new Date(date_y, date_m + 1, 0));
    setEndDateModified(false);
    // Value
    setValueLow("");
    setValueHigh("");
    // Category
    setCategorySelect(null);
  };
  const submitFilter = () => {
    var modelFilter = {
      searchText: -1,
      categoryFilter: -1,
      dateFilterStart: -1,
      dateFilterEnd: -1,
      valueFilterLow: -1,
      valueFilterHigh: -1,
    };
    if (startDateModified) modelFilter.dateFilterStart = startDate;
    if (endDateModified) modelFilter.dateFilterEnd = endDate;
    if (categorySelect != null) modelFilter.categoryFilter = categorySelect;
    if (valueLow != "") modelFilter.valueFilterLow = valueLow;
    if (valueHigh != "") modelFilter.valueFilterHigh = valueHigh;

    //console.log(modelFilter);
    setTransactionFilter(modelFilter, false);
    //Platform.OS != "web"
    //  ? disableTransactionFilterModal()
    //  : navigation.goBack();
    navigation.goBack();
  };
  const platfrom = Platform.OS;

  React.useEffect(() => {
    if (filterSet == true) {
      // Date
      if (currStartDate != -1) {
        setStartDate(currStartDate);
        setStartDateModified(true);
      }
      if (currEndDate != -1) {
        setEndDate(currEndDate);
        setEndDateModified(true);
      }
      if (currValueHigh != -1) {
        setValueHigh(currValueHigh);
      }
      if (currValueLow != -1) {
        setValueLow(currValueLow);
      }
      if (currCategory != -1) {
        setCategorySelect(currCategory);
      }
    }
  }, [filterSet]);

  return (
    <View style={GlobalStyles.containerW}>
      <View style={GlobalStyles.backgroundContainer}>
        <TouchableWithoutFeedback
          onPress={() => disableTransactionFilterModal()}
        >
          <Image style={GlobalStyles.backgroundImage} source={BGimage} />
        </TouchableWithoutFeedback>
      </View>

      <View style={styles.modalContainer}>
        <View style={GlobalStyles.headerTextP}>
          <View style={GlobalStyles.headingStyle}></View>
        </View>
        <View style={styles.filterContainer}>
          <Text style={styles.textTopHeader}>Filter Transactions</Text>
          <TouchableOpacity onPress={() => resetFilter()}>
            <View style={styles.resetContainerRow}>
              <Text style={styles.textReset}>RESET</Text>
              <FontAwesome style={styles.resetIcon} name="undo" size={20} />
            </View>
          </TouchableOpacity>
          <View style={styles.filterBox}>
            {platfrom === "web" ? (
              <View style={styles.filterDatesSet}>
                <View style={styles.filterDatesLeft}>
                  <Text style={styles.textStyleHeaderBlack}>Start Date</Text>
                  <TextInput
                    style={styles.textInputStyle}
                    underlineColorAndroid="transparent"
                    placeholder={"dd/mm/yyyy"} // value={startDate}
                    onChangeText={(text) => setStartDate(text)}
                  />
                </View>
                <View style={styles.filterDatesLeft}>
                  <Text style={styles.textStyleHeaderBlack}>End Date</Text>
                  <TextInput
                    style={styles.textInputStyle}
                    underlineColorAndroid="transparent"
                    placeholder={"dd/mm/yyyy"}
                    // value={startDate}
                    onChangeText={(text) => setEndDate(text)}
                  />
                </View>
              </View>
            ) : (
                <View style={styles.filterDates}>
                  <View style={styles.filterDatesLabels}>
                    <View style={styles.filterDatesLeft}>
                      <TouchableOpacity
                        style={styles.iconContainerRow}
                        onPress={showStartDateMode}
                      >
                        <Text style={styles.textStyleHeaderBlack}>
                          Start Date
                      </Text>
                        <Ionicons
                          style={styles.calIcon}
                          name="ios-calendar"
                          size={20}
                        />
                      </TouchableOpacity>
                    </View>
                    <View style={styles.filterDatesRight}>
                      <TouchableOpacity
                        style={styles.iconContainerRow}
                        onPress={showEndDateMode}
                      >
                        <Text style={styles.textStyleHeaderBlack}>End Date</Text>
                        <Ionicons
                          style={styles.calIcon}
                          name="ios-calendar"
                          size={20}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>

                  <View style={styles.filterDatesSet}>
                    <View style={styles.filterDatesLeft}>
                      <Text style={styles.filterDatesField}>
                        {startDateModified ? startDate.toDateString() : ""}
                      </Text>
                    </View>
                    <View style={styles.filterDatesRight}>
                      <Text style={styles.filterDatesField}>
                        {endDateModified ? endDate.toDateString() : ""}
                      </Text>
                    </View>
                  </View>
                  <DateTimePickerModal
                    isVisible={startDateShow}
                    mode="date"
                    onConfirm={onStartDateChange}
                    onCancel={() => setStartDateShow(false)}
                    isDarkModeEnabled={false}
                  />
                  <DateTimePickerModal
                    isVisible={endDateShow}
                    mode="date"
                    onConfirm={onEndDateChange}
                    onCancel={() => setEndDateShow(false)}
                    isDarkModeEnabled={false}
                  />
                </View>
              )}
            {/* CATEGORY PICKER */}
            {/* <View style={styles.filterCats}> </View> */}
            <DropDownPicker
              items={arrCategoryList}
              placeholder={"Select A Category"}
              searchablePlaceholder={"Select A Category"}
              searchable={true}
              containerStyle={{ height: 30 }}
              dropDownStyle={{ backgroundColor: "#FFFF", height: 300 }}
              dropDownMaxHeight={500}
              zIndex={500}
              itemStyle={{
                justifyContent: "flex-start",
              }}
              onChangeItem={(item) => setCategorySelect(item.value)}
            />

            <View style={styles.filterValue}>
              {/* VALUE RANGE */}

              <Text style={styles.textStyleHeaderBlack}>Value</Text>
              <View style={styles.filterDatesSet}>
                <View style={styles.filterDatesLeft}>
                  <TextInput
                    placeholder="Low"
                    style={styles.textInputStyle}
                    //keyboardType="number-pad"
                    underlineColorAndroid="transparent"
                    value={valueLow}
                    onChangeText={(text) => setValueLow(text)}
                  />
                </View>
                <View style={styles.filterDatesRight}>
                  <TextInput
                    placeholder="High"
                    style={styles.textInputStyle}
                    //keyboardType="number-pad"
                    underlineColorAndroid="transparent"
                    value={valueHigh}
                    onChangeText={(text) => setValueHigh(text)}
                  />
                </View>
              </View>
            </View>
            <View style={styles.bottomContainer}>
              <TouchableOpacity
                style={styles.SubmitButtonStyle}
                activeOpacity={0.5}
                onPress={() => submitFilter()}
              >
                <Text style={styles.textStyle}>APPLY FILTER</Text>
              </TouchableOpacity>

              {Platform.OS != "web" ? (
                <TouchableOpacity
                  style={styles.SubmitButtonStyle}
                  activeOpacity={0.5}
                  //onPress={() => disableTransactionFilterModal()}
                  onPress={() => navigation.goBack()}
                >
                  <Text style={styles.textStyle}>CANCEL</Text>
                </TouchableOpacity>
              ) : (
                  <TouchableOpacity
                    style={styles.SubmitButtonStyle}
                    activeOpacity={0.5}
                    onPress={() => navigation.goBack()}
                  >
                    <Text style={styles.textStyle}>CANCEL</Text>
                  </TouchableOpacity>
                )}
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  filterContainer: {},

  calIcon: {
    paddingLeft: 10,
    color: "#DDDDDD",
  },
  // filterCats: {
  //   zIndex: 10,
  //   borderColor: "#DDDDDD",
  //   borderWidth: 1,
  //   padding: 10,
  //   borderRadius: 3,
  // },

  textReset: {
    color: "#fff",
    textAlign: "left",
    fontFamily: "montserrat-medium",
    fontSize: 12,
  },

  resetIcon: {
    paddingLeft: 10,
    color: "#ffffff",
    fontSize: 24,
  },

  catButtonStyle: {
    //backgroundColor: '#337599',
    //color: '#ffffff',
  },

  resetContainerRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    marginRight: 30,
  },

  iconContainerRow: {
    flexDirection: "row",
  },

  filterCat: {
    marginBottom: 10,
    borderColor: "#DDDDDD",
    borderWidth: 1,
    padding: 10,
    borderRadius: 3,
  },

  filterValue: {
    borderColor: "#DDDDDD",
    borderWidth: 1,
    padding: 10,
    borderRadius: 3,
  },

  filterDates: {
    marginBottom: 10,
    borderColor: "#DDDDDD",
    borderWidth: 1,
    padding: 10,
    borderRadius: 3,
  },

  filterDatesLabels: {
    flexDirection: "row",
  },
  filterDatesSet: {
    flexDirection: "row",
  },
  filterDatesLeft: {
    flex: 1,
    flexDirection: "row",
    paddingBottom: 10,
    justifyContent: "center",
  },

  filterDatesRight: {
    flex: 1,
    flexDirection: "row",
    paddingBottom: 10,
    justifyContent: "center",
  },

  modalContainer: {
    flex: 1,
    justifyContent: "center",
    // width: 300,
    // height: 900,
  },

  closeBottom: {
    color: "#FFFF",
    textAlign: "right",
    marginTop: 25,
    marginBottom: 25,
    fontSize: 20,
  },

  centerHeaderContent: {
    justifyContent: "center",
    marginTop: 30,
  },

  SubmitButtonStyle: {
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
    marginBottom: 25,
  },

  bottomContainer: {
    justifyContent: "center",
    marginTop: 20,
    marginLeft: 10,
    marginRight: 10,
  },

  backArrow: {
    marginLeft: -30,
    paddingTop: 30,
    color: "#fff",
  },

  textStyleHeader: {
    color: "#fff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 16,
    marginLeft: 0,
    paddingTop: 10,
  },

  textTopHeader: {
    color: "#fff",
    textAlign: "left",
    fontFamily: "montserrat-medium",
    fontSize: 22,
    marginLeft: 50,
    paddingTop: 30,
    paddingBottom: 10,
  },

  textStyleHeaderBlack: {
    color: "#000",
    textAlign: "left",
    fontFamily: "montserrat-medium",
    fontSize: 14,
  },
  textStyle: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 16,
  },
  textInputStyle: {
    borderColor: "#666666",
    //height: 40,
    width: "80%",
    fontSize: 16,
    paddingRight: 10,
    fontFamily: "montserrat-regular",
    borderBottomColor: "#dddddd",
    borderBottomWidth: 1,
    textAlign: "center",
  },

  filterDatesField: {
    color: "#5499B7",
    textAlign: "right",
    fontFamily: "montserrat-medium",
    fontSize: 14,
  },

  filterBox: {
    backgroundColor: "#FFFF",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 15,
    paddingBottom: 15,
    marginLeft: 10,
    marginRight: 10,
    marginTop: 20,
    marginBottom: 15,
  },
});
